// ElyWellbeing platform data (frontend)
export const BRAND = { name: "ElyWellbeing", tagline: "Know Thyself, Heal Thyself.", location: "Ely, Cambridgeshire" };

export const NAV_LINKS = [
  { label: "Wu'sabat", to: "/musbat" },
  { label: "Learn", to: "/learn" },
  { label: "Discover", to: "/discover" },
  { label: "Live", to: "/live" },
  { label: "Transform", to: "/transform" },
  { label: "Herbs", to: "/herbs" },
  { label: "Calendar", to: "/calendar" },
  { label: "Blog", to: "/blog" },
];

// Grouped "browse intent" landing pages
export const GROUPS = {
  learn: {
    title: "Learn \u2014 Courses & Training",
    eyebrow: "STRUCTURED LEARNING",
    blurb: "Practitioner programmes, certifications and skills development for lasting change.",
    ids: ["wusabat_foundations", "maat_masterclass", "shadow_work", "breathwork", "nlp_practitioner", "nlp_master_practitioner", "nlp_trainer_training", "reiki", "reiki_master", "eft", "ballroom"],
  },
  discover: {
    title: "Discover \u2014 Seminars, Talks & Retreats",
    eyebrow: "INSIGHTS & IMMERSIONS",
    blurb: "Introductory talks, live seminars and our transformational Zanzibar island retreats.",
    ids: ["sitai", "ets", "island_awakening", "island_mastery", "maat_journaling_circle"],
  },
  live: {
    title: "Live Experiences \u2014 Live Wellbeing Sessions",
    eyebrow: "GATHER & RESTORE",
    blurb: "Daily live sessions \u2014 Group Reiki, sound baths, breathwork, journaling and guided meditation.",
    ids: ["reiki_group", "sound_bath", "breathwork_live", "maat_journaling_circle", "meditation_live"],
  },
  transform: {
    title: "Transform \u2014 Coaching & Breakthroughs",
    eyebrow: "DEEP CHANGE",
    blurb: "Guided meditation, breakthrough sessions, group and 1-to-1 coaching for lasting transformation.",
    ids: ["meditation_pack", "breakthrough", "nlp_coaching", "coaching_121"],
  },
};

// Browse-by shelves
export const BROWSE_GOALS = [
  { id: "sleep", label: "Sleep & Rest", color: "green", keys: ["sleep", "rest", "calm", "evening"] },
  { id: "stress", label: "Stress & Anxiety", color: "gold", keys: ["stress", "anxi", "calm", "reiki", "breath", "adaptogen"] },
  { id: "confidence", label: "Confidence & Leadership", color: "red", keys: ["confiden", "breakthrough", "speak", "nlp", "leader"] },
  { id: "energy", label: "Energy & Vitality", color: "red", keys: ["energy", "vital", "ginseng", "adaptogen", "morning"] },
  { id: "focus", label: "Focus & Cognition", color: "gold", keys: ["focus", "medita", "clarity", "nlp"] },
  { id: "grief", label: "Emotional Healing", color: "gold", keys: ["emotion", "grief", "shadow", "somatic", "journal"] },
];

export const BROWSE_TRADITIONS = [
  { id: "musbat", label: "Wu'sabat", color: "green", badges: ["Wu'sabat", "Ancient Wisdom"] },
  { id: "herbal", label: "Herbal Traditions", color: "green", cats: ["herb"], keys: ["herb", "materia", "adaptogen", "botan"] },
  { id: "modern", label: "Modern Integrative Science", color: "gold", badges: ["Evidence-Based"] },
];

export const BROWSE_MOODS = [
  { id: "wisdom", label: "Sacred & Ceremonial", color: "green" },
  { id: "rest", label: "Calm & Grounding", color: "green" },
  { id: "joy", label: "Energizing & Uplifting", color: "red" },
  { id: "purpose", label: "Deep & Introspective", color: "gold" },
  { id: "stuck", label: "Break Through", color: "red" },
  { id: "anxious", label: "Ease & Release", color: "gold" },
];

export const CATEGORY_META = {
  courses: { cat: "course", title: "Courses", eyebrow: "LEARN AT YOUR OWN PACE", blurb: "Structured programmes to build skills, mindset and mastery." },
  therapies: { cat: "therapy", title: "Therapies", eyebrow: "GUIDED, IN PERSON & ONLINE", blurb: "Reiki, NLP coaching and breakthrough sessions with our expert team." },
  herbs: { cat: "herb", title: "Herbs & Natural Living", eyebrow: "TRUSTED PARTNERS", blurb: "Curated botanicals from trusted UK & US partners on Amazon." },
  digital: { cat: "digital", title: "Digital Products", eyebrow: "INSTANT ACCESS", blurb: "Books, journals, meditations and guides to keep close." },
};

export const MOODS = [
  { id: "anxious", label: "I feel anxious", icon: "HeartPulse", desc: "Find calm and ease" },
  { id: "rest", label: "I need rest", icon: "Moon", desc: "Restore and unwind" },
  { id: "purpose", label: "I'm seeking purpose", icon: "Compass", desc: "Grow and transform" },
  { id: "wisdom", label: "I'm curious about ancient wisdom", icon: "ScrollText", desc: "Explore the Wu'sabat path" },
  { id: "joy", label: "I want to move & feel joy", icon: "Music", desc: "Dance and connect" },
  { id: "stuck", label: "I feel stuck", icon: "Unlock", desc: "Break through blocks" },
];

export const PRACTITIONER = {
  name: "Evan Jeposa",
  role: "Certified NLP Trainer & Leadership Coach",
  initials: "EJ",
  bio: "Evan integrates cutting-edge insights from NLP, coaching and leadership development to help individuals break through barriers and reach their full potential — the heart of the ElyWellbeing approach.",
};

export const TESTIMONIALS = [
  { name: "Gabby Smith", role: "Client", stars: 5, quote: "It was interesting to discover the root cause of my challenge and to finally release it. I experienced a profound shift and would highly recommend you." },
  { name: "Sarah Hellis", role: "Client", stars: 5, quote: "Loved the Reiki Session! Felt so relaxed thereafter and experienced a clarity that I have not had in a long while. Can't wait for my next session." },
  { name: "Maccoh Daliema", role: "Client", stars: 5, quote: "Speak It to Achieve It changed my perspective of my inner conversations. I talk to myself in a more loving way and my reality has changed as a result." },
];

export const PARTNERS = [
  { name: "Simply Supplements", note: "Trusted UK retailer of vitamins & herbs.", url: "" },
  { name: "Just Herbs Scotland", note: "Specialist UK herbal brand — member discount.", url: "" },
  { name: "Kräuterhaus Sanct Bernhard", note: "Century-old German natural remedies house.", url: "" },
];

// The 11 Laws of Maat (Wu'sabat framework — sample content, client-refinable)
export const MAAT_LAWS = [
  { n: 1, name: "AMEN", theme: "Truth & Peace", connection: "The foundation of peace — choosing inner calm over stress.", related: ["nlp_coaching", "meditation_pack", "herb_chamomile"] },
  { n: 2, name: "HETEP", theme: "Contentment & Gratitude", connection: "Satisfaction and gratitude as daily practice.", related: ["meditation_pack", "reiki_group"] },
  { n: 3, name: "MAA", theme: "Alignment & Honesty", connection: "Living in honest alignment with your true self.", related: ["sitai", "maat_journal"] },
  { n: 4, name: "TEKH", theme: "Balance & Harmony", connection: "Balancing work and rest, effort and ease.", related: ["better_sleep", "ballroom"] },
  { n: 5, name: "USHET", theme: "Order & Structure", connection: "Supportive routines that create calm.", related: ["better_sleep", "ets"] },
  { n: 6, name: "ARIU", theme: "Righteous Action", connection: "Deeds aligned with your values.", related: ["ets", "nlp_practitioner"] },
  { n: 7, name: "SEKHEM", theme: "Power & Vitality", connection: "Cultivating everyday energy and strength.", related: ["herb_ginseng", "ballroom"] },
  { n: 8, name: "HEH", theme: "Reciprocity", connection: "The healthy flow of giving and receiving.", related: ["reiki_group", "nlp_coaching"] },
  { n: 9, name: "NEB", theme: "Justice & Boundaries", connection: "Fairness to self and others.", related: ["breakthrough", "nlp_coaching"] },
  { n: 10, name: "NEFER", theme: "Beauty & Wholeness", connection: "Nurturing self-care and wholeness.", related: ["reiki_group", "herb_turmeric"] },
  { n: 11, name: "WABT", theme: "Purity & Clarity", connection: "A clear, uncluttered mind.", related: ["meditation_pack", "geometry_guide"] },
];

export const GEOMETRY = [
  { title: "The Golden Proportion", symbol: "φ", body: "The ratio (≈ 1.618) found in shells, plants and the human body — a template for balance and beauty in life and design." },
  { title: "The 3-4-5 Triangle", symbol: "△", body: "The sacred right triangle used by Egyptian builders — a symbol of stable foundations and right relationship." },
  { title: "The Eye of Horus", symbol: "𓅓", body: "An ancient emblem of protection, health and restoration, and of the fractional order within the whole." },
];

export const BALANCE_KEYS = [
  { key: "mental", label: "Mental" },
  { key: "physical", label: "Physical" },
  { key: "emotional", label: "Emotional" },
  { key: "spiritual", label: "Spiritual" },
  { key: "social", label: "Social" },
];
